import { createAsyncThunk } from "@reduxjs/toolkit";

import { handleFetch } from "src/api";
import { endPoints } from "src/shared/model";
import { RootState } from "src/app/model/store";

export const login = createAsyncThunk<
  string,
  void,
  { rejectValue: { email: string; password: string } }
>("auth/login", async (_, { getState, rejectWithValue }) => {
  const state = getState() as RootState;
  const email = state.auth.email;
  const password = state.auth.password;
  const remember = state.auth.rememberChecked;

  const response = await handleFetch<
    {
      email: string;
      password: string;
      remember: boolean;
    },
    { success: string; error: { email: string; password: string } }
  >({
    url: `${endPoints.auth}login/`,
    method: "POST",
    data: {
      email,
      password,
      remember,
    },
  });

  if (response && response.error) {
    return rejectWithValue(response.error);
  }

  return response.success;
});

export const getProtectedData = createAsyncThunk<string>(
  "auth/getProtectedData",
  async () => {
    const response = await handleFetch<
      undefined,
      {
        success: string;
      }
    >({ url: `${endPoints.auth}protected/`, method: "GET" });

    return response.success;
  },
);
